import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";
import i18n from '@/i18n'
import { thingService } from '@/services/thing.service.js'
import {VARILLA_REPORT_BY} from "@colven/common-domain-lib/lib/constants/reports-constants";

export default {
    name: 'ControlTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        setControlValues: {
            type: Boolean,
            required: true
        },
        disableReportSelector: {
            type: Boolean,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // data para el formulario
        chargeValueSetedZero: false,
        dischargeValueSetedZero: false,
        isValidForm: false,
        isSetControlValues: false,
        tanksQuantity: "",
        reportByAlreadySet: false,
        reportByOptions: [
            {
                value: VARILLA_REPORT_BY.ODOMETER,
                text: i18n.t('equipment.editDialog.trucks.reportByOdometer'),
                custom: false
            }, {
                value: VARILLA_REPORT_BY.HOURMETER,
                text: i18n.t('equipment.editDialog.trucks.reportByHourMeter'),
                custom: false
            }
        ],
        dischargeValue: Number,
        chargeValue: Number,
        defaultValuesLevelControl: {}, // {charge: Number, discharge: Number, tanks: Number}
        arrTanks: [] //  Array[String] que contiene las keys de los tanques, en realidad que no son 'charge' ni 'discharge'.
    }),
    computed: {
    },
    created() {
    },
    beforeDestroy() {
    },
    async mounted() {
        await this.getDefaultValues();

        this.arrTanks = Object.keys(this.model.varilla).filter((i) => i!=='charge' && i!=='discharge');
        
        if (this.arrTanks.length) {
            //   Se carga la cantidad de circuitos que tenia configurado el equipo
            // junto con los valores minimos de carga y descarga para varilla.
            this.isSetControlValues = true;
            this.disableReportSelector = true;
            this.tanksQuantity = this.arrTanks.length
            
            //   Si no tiene valores para minimos de carga y descarga para varilla se ponen 
            // los que tiene por defecto el sistema, que son traidos consumiendo el servicio de thing.
            if(!this.model.varilla.charge && this.chargeValueSetedZero){
                this.chargeValue = this.defaultValuesLevelControl.charge;
                this.model.varilla.charge = this.defaultValuesLevelControl.charge;
            }
            else this.chargeValue = this.model.varilla.charge;

            if(!this.model.varilla.discharge && this.dischargeValueSetedZero){
                this.dischargeValue = this.defaultValuesLevelControl.discharge;
                this.model.varilla.discharge = this.defaultValuesLevelControl.discharge;
            }
            else this.dischargeValue = this.model.varilla.discharge;
            
            if (!this.model.serviceType) {
                this.model.serviceType = "LIGHT_TRANSPORT";
            }
        } else {
            //   Por defecto, si el equipo no tiene valores cargados, se muestran 2 circuitos para cargar
            // y se genera el objeto con esa cantidad de circuitos.
            //   Los datos anteriormente mecionados se consumen de un endpoint para no tenerlos harcodeados,
            // junto con los valores minimos por defecto de carga y descarga para varilla.
            this.tanksQuantity = this.defaultValuesLevelControl.tanks;
            for(let i=1; i <= this.tanksQuantity; i++) this.arrTanks.push('tank' + i);

            this.chargeValue = this.defaultValuesLevelControl.charge;
            this.model.varilla.charge = this.defaultValuesLevelControl.charge;

            this.dischargeValue = this.defaultValuesLevelControl.discharge;
            this.model.varilla.discharge = this.defaultValuesLevelControl.discharge;

            this.model.serviceType = "LIGHT_TRANSPORT";
        }
    },
    methods: {
        async getDefaultValues() {
            this.defaultValuesLevelControl = (await thingService.getDefaultValuesLevelControl()).data;

        },
        updateModelValues(newValue, circuitNumber) {
            this.model.varilla[circuitNumber].capacity = parseInt(newValue);
        },
        updateChargeValue(newValue) {
            if(newValue==="") newValue = 0;
            this.model.varilla.charge = parseInt(newValue);
            this.chargeValueSetedZero = this.model.varilla.charge ? true : false;
        },
        updateDischargeValue(newValue) {
            if(newValue==="") newValue = 0;
            this.model.varilla.discharge = parseInt(newValue);
            this.dischargeValueSetedZero = this.model.varilla.discharge ? true : false;
        },
        tanksQuantityCangedTo(newQuantity) {
            this.tanksQuantity = parseInt(newQuantity);
            this.arrTanks = [];
            for(let i=1; i<=this.tanksQuantity; i++) this.arrTanks.push('tank' + i);
        },
        clearData() {
            this.tanksQuantity = ""
            this.model.serviceType = "LIGHT_TRANSPORT"
            this.model.reportBy = ""
        },
        updateForm() {
            // Si se habilita el check de calibrador, seteo en 2 circuitos por defecto
            // sino seteo objeto null
            if (this.setControlValues && this.model.varilla && this.arrTanks.length === 0) {
                this.model.serviceType = "LIGHT_TRANSPORT"
                this.tanksQuantity = this.defaultValuesLevelControl.tanks;
                this.chargeValue = this.defaultValuesLevelControl.charge;
                this.dischargeValue = this.defaultValuesLevelControl.discharge;
                this.model.varilla = {}
            }
            else {
                this.tanksQuantity = 0
                this.model.varilla = null
                this.model.serviceType = null
            }
        },
        consumeKeys(event, key) {
            if (event.key == 'Backspace') return;

            let boolean = /^\d*(\.\d{1})?\d{0}$/.test(this.model.varilla[key].capacity);

            if (!boolean) {
                event.preventDefault();
            }
        },
        reportBySelected(newValue) {
            this.model.reportBy = newValue.value ? newValue.value : ""
        }
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.controlTabForm) {
                this.$refs.controlTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        
        /**
         * Metodo que se encarga de armar el formulario y cargar valores segun la cantidad de circuitos
         * @param {*} tanksNumber
         */
        tanksQuantity(tanksNumber) {
            if (tanksNumber && tanksNumber !== "") {
                if (tanksNumber >= 1 && tanksNumber <= 4) { // entre 2 y 6 circuitos validos
                    // si ya tenia valores cargados
                    if (this.model.varilla) {
                        // si aumento la cantidad de circuitos que tenia el equipo
                        const modelTanks = this.arrTanks.length
                        if (tanksNumber >= modelTanks) {
                            for (let index = 0; index < tanksNumber; index++) {
                                const element = this.model.varilla[`tank${index + 1}`]
                                if (!element) {
                                    this.model.varilla[`tank${index + 1}`] = {
                                        capacity: 0
                                    }
                                }

                            }
                            // si la cantidad disminuye
                        } else {
                            for (let i = 0; i < modelTanks; i++) {
                                if ((i + 1) > tanksNumber) {
                                    delete this.model.varilla[`tank${i + 1}`]
                                }
                            }
                        }
                        // cargar valores desde cero
                    } else {
                        let hdwNumber = {}
                        for (let index = 0; index < this.tanksQuantity; index++) {
                            hdwNumber[`tank${index + 1}`] = {
                                capacity: 0
                            }
                        }
                        this.model.varilla = hdwNumber
                    }
                }
            }
        }
    }
}
